import React from "react";

import "./Charts.css";

const SingleCardList = ({ estacao, total }) => {
    return (estacao) ? (
        <li className="list-group-item note_card_item_conatiner">
            <span className="material-symbols-outlined note_card_item_label_icon note_card_item">task_alt</span>
            <span className="note_card_item_paragraph note_card_item">{estacao}</span>
            <div className="estacao_total_container">
                <b className="note_card_item">{total}</b>
                <small className="note_card_item_paragraph">Estações</small>
            </div>
            <span className="material-symbols-outlined note_card_item_chart_icon note_card_item">bar_chart</span>
        </li>
    ) : "";
};

const NotesCardList = ({ usuarioId, actorsResults }) => {
    const scoresFilter = actorsResults.filter(actor => actor.usuarioId === usuarioId);

    const scoresCount = scoresFilter.reduce((acc, item) => {
        acc[item.estacao] = (acc[item.estacao] || 0) + 1;
        return acc;
    }, {});

    const scoresArray = Object.entries(scoresCount).map(([estacao, total]) => ({
        estacao,
        total
    }));

    return (scoresFilter && scoresFilter.length > 0) ? (
        <ul className="list-group">
            {
                scoresArray.map((data, index) => (
                    <SingleCardList
                        key={`${index}`}
                        estacao={data.estacao}
                        total={data.total}
                    />
                ))
            }
        </ul>
    ) : "";
};

export default NotesCardList;